module.exports = __webpack_public_path__ + "img/TECHNOLOGY-BALENO-1.a3c99582.jpg";